import DTextField from "components/common/DTextField";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import resource from "pages/EmployeeWorkspace/Resources/associationResource";
/*import RHFSelect from "components/forms/RHFSelect";*/

export default function TabForm({ register, errors, control }) {
    return (
        <GridContainer spacing={2}>
            <GridItem xs={12} md={12}>
                <DTextField
                    name={resource.fields.name.name}
                    label={resource.fields.name.label}
                    required={resource.fields.name.required}
                    options={resource.fields.name.options ?? []}
                    multiline
                    error={!!errors.name}
                    {...register(resource.fields.name.name)}
                />
            </GridItem>
        </GridContainer>
    );
}
